import { Injectable, Optional } from '@angular/core';
import { AuthConfig } from 'angular-oauth2-oidc';

export class JZAuthModuleConfig {
  static MODULE_NAME = 'jz-auth-module';
  environment?: any;
  enable = true;
  authConfig: AuthConfig;
}

@Injectable({ providedIn: 'root' })
export class JZAuthModuleConfigService {
  private _config = new JZAuthModuleConfig();

  get environment(): any {
    return this._config.environment;
  }

  get appCode(): string {
    return this._config.environment.application.appCode;
  }

  getApiUrls(moduleName: string): string {
    if (this.environment.apis[moduleName]) { return this.environment.apis[moduleName].url; }
    else { return this.environment.apis.default.url; }
  }

  constructor(@Optional() config?: JZAuthModuleConfig) {
    if (config) {
      this._config = config;
    }
  }
}
